import React from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { updateAccount } from "@api/account"
import CountrySelect from "@src/components/country_select/"
import Button from "@src/components/button"

const SignUpForm = ({ account, updateAccount, countries, festival, showButton, buttonText, onButtonClick, disabled, buttonStatus, hideCountry }) => {
  return (
    <>
      {festival && <div className={'border-bottom border-gray-5 mb3 pb3'}>
        <label className='cs-label' htmlFor={`__input-festival`}>Festival Name</label>
        <input
          autoFocus={true}
          value={account.festival}
          data-test-id={`account-festival-input`}
          className={`cs-input col-12 ${account.validation_errors.includes('festival') ? "error" : ""}`}
          type={'text'}
          id={`__input-festival`}
          onChange={event => updateAccount({ festival: event.target.value })}/>
      </div>}
      <label className='cs-label' htmlFor={`__input-name`}>Name</label>
      <input
        autoFocus={true}
        value={account.full_name}
        data-test-id={`account-name-input`}
        className={`cs-input col-12 ${account.validation_errors.includes('full_name') ? "error" : ""}`}
        type={'text'}
        id={`__input-name`}
        onChange={event => updateAccount({ full_name: event.target.value })}/>
      <label className='cs-label mt2' htmlFor={`__input-email`}>Email</label>
      <input
        value={account.email}
        data-test-id={`account-email-input`}
        className={`cs-input col-12 ${account.validation_errors.includes('email') ? "error" : ""}`}
        type={'text'}
        id={`__input-email`}
        onChange={event => updateAccount({ email: event.target.value })}/>
      {account.validation_errors.includes('email') && (
        <small
          style={{
            marginTop: '0.3em'
          }}
          data-test-id={`account-email-error-text`}
          className='block red'>
          Valid email is required.
        </small>
      )}
      <label className='cs-label mt2'  htmlFor={`__input-password`}>Password</label>
      <input
        value={account.password}
        data-test-id={`account-password-input`}
        className={`cs-input col-12 ${account.validation_errors.includes('password') ? "error" : ""}`}
        type={'password'}
        id={`__input-password`}
        onChange={event => updateAccount({ password: event.target.value })}/>
      {account.validation_errors.includes('password') && (
        <small
          style={{
            marginTop: '0.3em'
          }}
          data-test-id={`account-password-error-text`}
          className='block red'>
          Password is required.
        </small>
      )}
      {!hideCountry &&
        <CountrySelect
          value={account.country_code}
          onChange={value => updateAccount({ country_code: value })}
        />}
      {account.error_message && (
        <small data-test-id='account-error-text' className='red block mt1 mb2'>
          {account.error_message}
        </small>
      )}
      {showButton && (
        <Button
          id='cinesend-signup-form-button'
          type='submit'
          tabIndex='1'
          data-test-id='account-submit-btn'
          onClick={onButtonClick}
          disabled={disabled}
          className={`cs-button ${buttonStatus || 'ready'} col-12 mt2`}>
          {buttonText}
        </Button>
      )}
    </>
  )
}

const mapStateToProps = state => ({
  account: state.account,
  countries: state.utilities.countries.list,
})

const mapDispatchToProps = dispatch => ({
  updateAccount: bindActionCreators(updateAccount, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(SignUpForm)
